export default __webpack_public_path__ + "static/gantmodern-regular-5adbb6b59ab5cb617d986e2046a79de2.woff";